import React from 'react';
import Sidebar from './Sidebar.js';
import Header from './Header.js';

const MainLayout = ({ children, title = 'Dashboard', userRole = 'respondent', user = null }) => {
  return (
    <div className="flex h-screen bg-slate-50" data-testid="main-layout">
      <Sidebar userRole={userRole} />
      
      <div className="flex-1 ml-64 flex flex-col">
        <Header title={title} user={user} />
        
        <main className="flex-1 overflow-y-auto p-8" data-testid="main-content">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;